$(function() {
    if($("#application_event_accept_content").length){
        $(".radio").click(check_application_content_accepted);
        check_application_content_accepted()
    }
    $("#accept_content_btn").on("click", function() {
        if ($("#application_event_accept_content")[0].checked == true) {
            $("#myModal").modal('show')
        }else if ($("#application_event_reject_content_staff")[0].checked == true || $("#application_event_reject_content_applicant")[0].checked == true) {
            $("#accept_content_submit_btn").parents('form').submit()
        }
    });
});

function check_application_content_accepted(){
    if ($("#application_event_reject_content_staff")[0].checked == true || $("#application_event_reject_content_applicant")[0].checked == true) {
        $("div.application_comment").show()
    }else{
        $("div.application_comment").hide()
    }
}


